import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

const fetchGamesEnding = (retailerId) => {
  const { url } = DepsService.rest.widgets.gamesEnding;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default fetchGamesEnding;



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/games-ending.api.js